import { useEffect, useState, useMemo } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// PMS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// PMS examples
import DataTable from "examples/Tables/DataTable";
// Data
import { centsToDollars } from "global/functions";
import { Stack } from "@mui/material";

function Projects(props) {
  const [data1, setData] = useState({});

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const data = useMemo(() => {
    return {
      columns: [
        {
          Header: "Name",
          accessor: "name",
          width: "30%",
          align: "left",
        },
        {
          Header: "Contact Info.",
          accessor: "contact",
          width: "30%",
          align: "left",
        },
        {
          Header: "LicensePlate",
          accessor: "licensePlate",
          width: "20%",
          align: "left",
        },
        {
          Header: "Bookings",
          accessor: "reservationCount",
          width: "10%",
          align: "left",
        },
        {
          Header: "Amount",
          accessor: "totalAmount",
          width: "10%",
          align: "center",
        },
      ],
      rows:
        Array.isArray(data1.topFive) && data1.topFive.length > 0
          ? data1?.topFive.map((user, index) => ({
              name: (
                <MDBox
                  display="flex"
                  color="text.primary"
                  py={1}
                  whiteSpace="nowrap"
                >
                  {user?.customerInfo?.firstName}
                  {""} {user?.customerInfo?.lastName}
                </MDBox>
              ),
              contact: (
                <Stack direction="row" spacing={1.5} alignItems="center">
                  {user?.customerInfo?.mobile && (
                    <>
                      <a
                        href={`tel:${user.customerInfo.mobile}`}
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          color: "inherit",
                          alignItems: "center",
                          marginRight: 2,
                        }}
                      >
                        <Icon sx={{ fontSize: 20 }}>call</Icon>
                      </a>
                      {user.customerInfo.mobile}
                    </>
                  )}

                  {user?.customerInfo?.email && (
                    <>
                      <a
                        href={`mailto:${user.customerInfo.email}`}
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          marginRight: 2,
                          color: "inherit",
                        }}
                      >
                        <Icon sx={{ fontSize: 20 }}>email</Icon>
                      </a>
                      {user.customerInfo.email}
                    </>
                  )}
                </Stack>
              ),

              licensePlate: (
                <MDBox display="flex" color="text.primary" py={1}>
                  {user?._id?.licensePlate}
                </MDBox>
              ),
              reservationCount: (
                <MDTypography
                  variant="caption"
                  color="text.primary"
                  fontWeight="medium"
                >
                  {user?.reservationCount}
                </MDTypography>
              ),
              totalAmount: (
                <MDBox width="8rem" textAlign="center">
                  <MDTypography
                    variant="caption"
                    color="text.primary"
                    fontWeight="medium"
                  >
                    ${centsToDollars(user?.totalAmount || 0)}
                  </MDTypography>
                </MDBox>
              ),
              key: index.toString(),
            }))
          : [],
    };
  }, [data1?.topFive]);

  const { columns, rows } = data;

  return (
    <Card>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={3}
      >
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            Repeat Customers
          </MDTypography>
          <MDBox display="flex" alignItems="center" lineHeight={0}>
            <Icon
              sx={{
                fontWeight: "bold",
                color: ({ palette: { info } }) => info.main,
                mt: -0.5,
              }}
            >
              done
            </Icon>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;<strong>{data1?.totalCount}</strong> customers with more
              than one transaction this month.
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />
      </MDBox>
    </Card>
  );
}

export default Projects;
